import { createAction, props } from '@ngrx/store';

import { type CanvasElementId } from '@blaze-runtime/engine-domain';
import { type StyleSheet } from '@blaze-shared/theming-domain';
import { type Connection, type Workflow } from '@blaze-shared/workflow-domain';

import { type CanvasElementDefinitionInternal } from '../../canvas-elements/element-definition';
const TAG = '[Generation]';

export const containerActionsRegenerationRequest = createAction(
  `${TAG} Container actions regenerated request`,
  props<{
    buttonDefinition: CanvasElementDefinitionInternal<'button'>;
    containerId: CanvasElementId;
    styleSheets: StyleSheet[];
    actionsLayoutChanged: boolean;
  }>(),
);

export const containerActionsRegenerationUpdateWorkflows = createAction(
  `${TAG} Container actions regenerated - process`,
  props<{
    containerId: CanvasElementId | undefined;
    refsConnections: Connection[];
    updatedWorkflows: Workflow[];
  }>(),
);

export const containerActionsRegenerationCompleted = createAction(
  `${TAG} Container actions regenerated completed`,
  props<{ workflow: Workflow; elementId?: string | null }>(),
);
